<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header consolidado                                            -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap items-end justify-between gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Inscripciones</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Cesiones de cupo</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Cesiones de Cupo</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ totalRecords }} cesiones registradas · Historial de transferencias de inscripciones entre participantes
      </p>
    </div>

    <a routerLink="/enrollment-transfers/new" class="btn btn-primary">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
      </svg>
      Nueva Cesión
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- KPI principal (1 grande) + pills de breakdown                -->
  <!-- ============================================================ -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

    <div class="kpi-card kpi-violet">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
        </span>
        Total Cesiones
      </div>
      <div class="kpi-value">{{ totalRecords }}</div>
      <div class="kpi-hint">Histórico completo</div>
    </div>

    <div class="kpi-card kpi-sky">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </span>
        Individuales
      </div>
      <div class="kpi-value">{{ countIndividual() }}</div>
      <div class="kpi-hint tabular-nums">En esta página · {{ transfers.length }} visibles</div>
    </div>

    <div class="kpi-card kpi-amber">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </span>
        Empresariales
      </div>
      <div class="kpi-value">{{ countCorporate() }}</div>
      <div class="kpi-hint tabular-nums">En esta página · {{ transfers.length }} visibles</div>
    </div>

    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Última cesión
      </div>
      <div class="kpi-value text-base">{{ lastTransferDate() }}</div>
      <div class="kpi-hint">{{ lastTransferLabel() }}</div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros                                            -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <!-- Buscar -->
      <div class="col-span-12 md:col-span-6">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none"
            stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onFilterChange()"
            placeholder="Buscar por documento, nombre de participante o proyecto..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <!-- Fecha desde -->
      <div class="col-span-6 md:col-span-3">
        <p-calendar [(ngModel)]="fromDate" (onSelect)="onFilterChange()" (onClear)="onFilterChange()"
          placeholder="Desde" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          [showIcon]="true" appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>

      <!-- Fecha hasta -->
      <div class="col-span-6 md:col-span-3">
        <p-calendar [(ngModel)]="toDate" (onSelect)="onFilterChange()" (onClear)="onFilterChange()"
          placeholder="Hasta" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          [showIcon]="true" appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Tabla de Cesiones                                             -->
  <!-- ============================================================ -->
  <div class="rounded-xl border border-slate-200 bg-white overflow-x-auto">
    <table class="enrollment-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Tipo</th>
          <th>Fecha</th>
          <th>Origen</th>
          <th>Destino</th>
          <th>Inscripción · Proyecto</th>
          <th>Motivo</th>
          <th>Realizado por</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>

        <!-- Empty state -->
        <tr *ngIf="transfers.length === 0">
          <td colspan="9" class="text-center py-10">
            <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
              <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
            </div>
            <p class="text-sm font-medium text-slate-700">No hay cesiones de cupo registradas</p>
            <a routerLink="/enrollment-transfers/new" class="btn btn-secondary btn-sm mt-3 inline-flex">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
              </svg>
              Crear primera cesión
            </a>
          </td>
        </tr>

        <!-- Filas de datos -->
        <tr *ngFor="let transfer of transfers">

          <!-- ID -->
          <td class="tabular-nums font-medium text-slate-700">
            #{{ transfer.id }}
          </td>

          <!-- Tipo -->
          <td>
            <span class="pill" [ngClass]="transfer.isCorporate ? 'pill-violet' : 'pill-sky'">
              <svg *ngIf="!transfer.isCorporate" class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <svg *ngIf="transfer.isCorporate" class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1" />
              </svg>
              {{ transfer.isCorporate ? 'Empresarial' : 'Individual' }}
            </span>
            <p *ngIf="transfer.isCorporate && transfer.companyName"
              class="text-[11px] text-slate-500 mt-1 truncate max-w-[140px]" [title]="transfer.companyName">
              {{ transfer.companyName }}
            </p>
          </td>

          <!-- Fecha -->
          <td class="text-slate-600 tabular-nums">
            {{ transfer.transferDate | date:'dd/MM/yy' }}
            <span class="block text-[11px] text-slate-400 tabular-nums">{{ transfer.transferDate | date:'HH:mm' }}</span>
          </td>

          <!-- Origen -->
          <td>
            <div class="participant-cell">
              <div class="initials-avatar tone-from"
                [title]="'Origen — ' + (transfer.fromParticipant?.firstName || '') + ' ' + (transfer.fromParticipant?.lastName || '')">
                {{ getInitials(transfer.fromParticipant?.firstName || '', transfer.fromParticipant?.lastName || '') }}
              </div>
              <div class="participant-meta">
                <div class="participant-name">
                  {{ transfer.fromParticipant?.firstName }} {{ transfer.fromParticipant?.lastName }}
                </div>
                <div class="participant-email tabular-nums">{{ transfer.fromParticipant?.documentId }}</div>
              </div>
            </div>
          </td>

          <!-- Destino -->
          <td>
            <div class="participant-cell">
              <div class="initials-avatar tone-to"
                [title]="'Destino — ' + (transfer.toParticipant?.firstName || '') + ' ' + (transfer.toParticipant?.lastName || '')">
                {{ getInitials(transfer.toParticipant?.firstName || '', transfer.toParticipant?.lastName || '') }}
              </div>
              <div class="participant-meta">
                <div class="participant-name">
                  {{ transfer.toParticipant?.firstName }} {{ transfer.toParticipant?.lastName }}
                </div>
                <div class="participant-email tabular-nums">{{ transfer.toParticipant?.documentId }}</div>
              </div>
            </div>
          </td>

          <!-- Inscripción / Proyecto -->
          <td>
            <div class="flex flex-col gap-1 min-w-0">
              <a *ngIf="!transfer.isCorporate && transfer.enrollmentId"
                [routerLink]="['/dashboard/enrollments/view-v2', transfer.enrollmentId]"
                class="pill pill-sky hover:opacity-80 transition-opacity w-fit">
                Inscripción #<span class="tabular-nums">{{ transfer.enrollmentId }}</span>
              </a>
              <a *ngIf="transfer.isCorporate && transfer.corporateEnrollmentId"
                [routerLink]="['/dashboard/enrollments/corporate/view-v2', transfer.corporateEnrollmentId]"
                class="pill pill-violet hover:opacity-80 transition-opacity w-fit">
                Corp. #<span class="tabular-nums">{{ transfer.corporateEnrollmentId }}</span>
              </a>
              <div class="project-chip" *ngIf="transfer.project?.name">
                <span class="project-code" *ngIf="transfer.project?.projectId">{{ transfer.project.projectId }}</span>
                <span class="project-name" [title]="transfer.project?.name">{{ transfer.project?.name }}</span>
              </div>
            </div>
          </td>

          <!-- Motivo -->
          <td>
            <span *ngIf="transfer.reason" class="text-sm text-slate-700 line-clamp-2 max-w-[180px]" [title]="transfer.reason">
              {{ transfer.reason }}
            </span>
            <span *ngIf="!transfer.reason" class="text-xs text-slate-400 italic">Sin motivo</span>
          </td>

          <!-- Realizado por -->
          <td>
            <span class="text-xs text-slate-600 truncate max-w-[180px] inline-block"
              [title]="transfer.transferredByUserEmail || 'Sistema'">
              {{ transfer.transferredByUserEmail || 'Sistema' }}
            </span>
          </td>

          <!-- Acciones -->
          <td class="text-right">
            <a *ngIf="!transfer.isCorporate && transfer.enrollmentId"
              [routerLink]="['/dashboard/enrollments/view-v2', transfer.enrollmentId]"
              class="row-action row-action--primary" title="Ver inscripción individual">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
              <span>Ver</span>
            </a>
            <a *ngIf="transfer.isCorporate && transfer.corporateEnrollmentId"
              [routerLink]="['/dashboard/enrollments/corporate/view-v2', transfer.corporateEnrollmentId]"
              class="row-action row-action--primary" title="Ver inscripción empresarial">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
              <span>Ver</span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginador -->
  <div *ngIf="totalRecords > 0" class="bg-white rounded-xl border border-slate-200">
    <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
    </p-paginator>
  </div>

</div>
